import * as React from "react";
const EmergencyTelecommunicationsIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 56 56",
  "aria-hidden": "true",
  fill: "currentColor",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M39.989 46.971H29.987v-28.5c0-.018-.004-.034-.005-.052a4 4 0 1 0-3.99 0c0 .018-.004.034-.004.051v28.501h-10a2 2 0 0 0 0 4h24a2 2 0 1 0 0-4h.001Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.7 21.658c.556.61 1.832.33 2.543-.78a10.969 10.969 0 0 0 0-11.813c-.711-1.11-1.987-1.39-2.544-.78a2.03 2.03 0 0 0 .016 2.397 7.966 7.966 0 0 1 0 8.578 2.03 2.03 0 0 0-.016 2.398Zm8.693-14.705c-.72-.998-1.93-1.225-2.494-.62a1.916 1.916 0 0 0 .059 2.373 10.727 10.727 0 0 1 0 12.53 1.916 1.916 0 0 0-.06 2.375c.566.603 1.776.376 2.495-.62a13.73 13.73 0 0 0 0-16.038ZM21.178 21.658a2.03 2.03 0 0 0-.017-2.398 7.967 7.967 0 0 1 0-8.578 2.03 2.03 0 0 0 .017-2.397c-.557-.61-1.833-.33-2.544.78a10.97 10.97 0 0 0 0 11.813c.71 1.11 1.986 1.39 2.544.78Zm-6.1 1.952a1.915 1.915 0 0 0-.06-2.374 10.727 10.727 0 0 1 0-12.53 1.916 1.916 0 0 0 .061-2.374c-.565-.603-1.776-.377-2.494.62a13.73 13.73 0 0 0 0 16.038c.718.997 1.93 1.224 2.494.62Z"
}));
export default EmergencyTelecommunicationsIcon;